import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/Users/giovambattistafazioli/Lavori/Github/react-toggle/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

var scope_1 = require('/Users/giovambattistafazioli/Lavori/Github/react-toggle/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2afc9f309f94a6944c84d68f7c5b2409.js')["default"];

var scope_2 = require('/Users/giovambattistafazioli/Lavori/Github/react-toggle/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8f90dc32d3a3db9d080366c5a9d4e8c4.js')["default"];

var scope_3 = require('/Users/giovambattistafazioli/Lavori/Github/react-toggle/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/aff60e232df30b7bb32bbb4f42e378cf.js')["default"];

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3);